module.exports = __webpack_public_path__ + "static/media/mideclipse.9aae08a9.svg";